import React from 'react';

// Formatação do WhatsApp: *negrito*, _itálico_, ~riscado~ — só nas bordas de palavra (como o app faz)
export const WA_FMT = /(^|[\s([{"'])([*_~])(\S(?:[^\n]*?\S)?)\2(?=$|[\s.,!?:;)\]}"'])/g;
export function formatWa(text) {
  const out = []; let last = 0; let m; let k = 0;
  WA_FMT.lastIndex = 0;
  while ((m = WA_FMT.exec(text))) {
    const ini = m.index + m[1].length;
    if (ini > last) out.push(text.slice(last, ini));
    const Tag = m[2] === '*' ? 'strong' : m[2] === '_' ? 'em' : 's';
    out.push(<Tag key={k++}>{m[3]}</Tag>);
    last = ini + m[3].length + 2;
    WA_FMT.lastIndex = last;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
export const semMarcas = (t = '') => t.replace(WA_FMT, '$1$3');

